module.exports = __webpack_public_path__ + "res/22-img_play.406335d2fe356a195c789ad167cf9604.png";